;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('productIcon', productIcon)

  /* @ngInject */
  function productIcon () {
    return {
      restrict: 'E',
      scope: {
        slug: '@'
      },
      templateNamespace: 'svg',
      link: function (scope) {
        scope.getContentUrl = function () {
          switch (scope.slug) {
            case 'birthday-card':
            case 'social-media-post':
            case 'linkedin-post':
            case 'card-digital':
            case 'video-thumbnail':
            case 'adesivos':
            case 'banner-90x200':
            case 'banner-100x150':
            case 'banner-90x120':
            case 'banner-80x120':
              scope.slug = 'card-digital'
              break
            case 'poster-a3':
            case 'poster-a2':
            case 'poster-a4':
            case 'poster-a5':
              scope.slug = 'poster-a2'
              break
            case 'flyer-10x15':
            case 'flyer-15x21':
            case 'flyer-20x21':
              scope.slug = 'flyer-a4'
              break
            case 'sheet-a3':
            case 'sheet-a4':
              scope.slug = 'sheet'
              break
            case 'sheet-a3-horizontal':
            case 'sheet-a4-horizontal':
              scope.slug = 'sheet-horizontal'
              break
            case 'email-marketing':
            case 'email-footer':
              scope.slug = 'email-footer'
              break
            case 'business-card':
              scope.slug = 'business-card'
              break
            case 'facebook-cover':
              scope.slug = 'facebook-cover'
              break
            case 'facebook-ads':
              scope.slug = 'facebook-ads'
              break
            case 'instagram-ads':
              scope.slug = 'instagram-ads'
              break
            case 'facebook-post':
              scope.slug = 'facebook-post'
              break
            case 'full-hd-television':
              scope.slug = 'full-hd-television'
              break
            case 'instagram-post':
              scope.slug = 'instagram-post'
              break
            case 'invite':
              scope.slug = 'invite-a4'
              break
            case 'post-whatsapp':
              scope.slug = 'post-whatsapp'
              break
            case 'stories-instagram-post':
              scope.slug = 'stories-instagram-post'
              break
            case 'stories-whatsapp-post':
              scope.slug = 'stories-whatsapp-post'
              break
            case 'twitter-ads':
              scope.slug = 'twitter-ads'
              break
            case 'twitter-cover':
              scope.slug = 'twitter-cover'
              break
            case 'twitter-post':
              scope.slug = 'twitter-post'
              break
            case 'video-instagram':
              scope.slug = 'video-instagram'
              break
            case 'facebook-profile':
              scope.slug = 'facebook-profile'
              break
            case 'instagram-profile':
              scope.slug = 'facebook-profile'
              break
            default:
              scope.slug = 'default'
          }

          return `/assets/icons/products/${scope.slug}.svg`
        }
      },
      template: '<div ng-if="slug" ng-include="getContentUrl()"></div>'
    }
  }
})()
